import store from './store/index';

export default store;
